module.exports = __webpack_public_path__ + "img/residencial.03bbfe0f.svg";